import { inject, Injectable } from '@angular/core';
import * as kanbanStagesActions from './kanban-stages.actions';
import * as kanbanStagesSelectors from './kanban-stages.selectors';
import { State } from './kanban-stages.reducer';
import { KanbanStage, KanbanType } from '@wdx/clmi/clmi-swagger-gen';
import { Store } from '@ngrx/store';
import { filter, Observable, tap } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class KanbanStagesFacadeService {
    private store = inject(Store) as Store<{
        kanbanStages: State;
    }>;

    public kanbanStages$(kanbanTypeId = 'Pipeline'): Observable<KanbanStage[]> {
        return this.store
            .select(kanbanStagesSelectors.getList, {
                kanbanTypeId,
            })
            .pipe(
                tap((kanbanStages) => {
                    if (!kanbanStages) {
                        this.store.dispatch(
                            kanbanStagesActions.getForKanbanType({
                                kanbanTypeId,
                            }),
                        );
                    }
                }),
                filter(Boolean),
            );
    }
}
